module.exports = __webpack_public_path__ + "static/media/20170929_160549.13f5bb29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery-pl/20170929_160549.jpg
// module id = 467
// module chunks = 0